/**
 * NOT SORRY — Drop 3.0 site config.
 * Edit and refresh. No build step.
 */
window.NOT_SORRY_CONFIG = {
  /* ------------------------------------------------------------------
   * PRICING TIER  — the only switch you need on launch day.
   *   "preorder" → pre-order pricing, cap at 20, bundles include a FREE cap
   *   "launch"   → standard pricing, cap at 25, bundles without the free cap
   * ------------------------------------------------------------------ */
  TIER: "preorder",

  CURRENCY: "AED",

  PRICES: {
    preorder: {
      tee: 89,
      shorts: 69,
      cap: 20,
      duo: 149,          // tee + shorts
      trio: 239,         // 2 tees + shorts
      bundleFreeCap: true,
      label: "Pre-order",
    },
    launch: {
      tee: 89,
      shorts: 69,
      cap: 25,
      duo: 169,
      trio: 269,
      bundleFreeCap: false,
      label: "Launch",
    },
  },

  /* Storefront root. Buy buttons append /cart/{variantId}:1 to it, which drops
     the shopper straight into checkout with the right size already chosen. */
  SHOP_URL: "",

  /* "shopify" talks to the real AJAX cart; "local" is a localStorage stand-in
     so the drawer can be worked on without a store behind it. */
  CART_MODE: "shopify",

  /* How the site links to itself. Locally these are flat files; on Shopify the
     same pages live at / and /products/<handle>, so only this block changes. */
  ROUTES: {
    home: "/",
    product: p => "/products/" + p.handle,
  },

  SOCIAL: {
    instagram: "https://instagram.com/not.motorsport",
    tiktok: "",
    youtube: "",
  },
};
